import { render } from "./PagePost.vue?vue&type=template&id=6f534710"
import script from "./PagePost.vue?vue&type=script&lang=js"
export * from "./PagePost.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__